<ul class="nav">
  <li>
    <a dsRouterLink="/faq/policy">Policies</a>
  </li>
  <li>
    <a dsRouterLink="/faq/claims">Claims</a>
  </li>
  @if (!isPartner) {
    <li>
      <a dsRouterLink="/faq/go-paperless">Go Paperless</a>
    </li>
  }
  @if (isPartner) {
    <li>
      <a dsRouterLink="/faq/billing">Billing</a>
    </li>
  }
</ul>
